import { callSvcAxiosInstance } from "@/constants";
import { callServiceEndpoints } from "@/constants/endpoints";
import { AgentSeatAssignment, CreateAgentSeatAssignmentDto } from "@/types/agent-seat-assignment.types";

class AgentSeatAssignmentService {
    async getAll(): Promise<AgentSeatAssignment[]> {
        const response = await callSvcAxiosInstance.get<AgentSeatAssignment[]>(
            callServiceEndpoints.getAgentSeatAssignments
        );
        return response.data;
    }

    async create(data: CreateAgentSeatAssignmentDto): Promise<AgentSeatAssignment> {
        const response = await callSvcAxiosInstance.post<AgentSeatAssignment>(
            callServiceEndpoints.createAgentSeatAssignment,
            data
        );
        return response.data;
    }

    async update(
        tableId: string,
        seatNumber: number,
        update: Partial<AgentSeatAssignment>
    ): Promise<AgentSeatAssignment> {
        const response = await callSvcAxiosInstance.put<AgentSeatAssignment>(
            callServiceEndpoints.updateAgentSeatAssignment(tableId, seatNumber),
            update
        );
        return response.data;
    }

    async delete(tableId: string, seatNumber: number): Promise<boolean> {
        const response = await callSvcAxiosInstance.delete(
            callServiceEndpoints.deleteAgentSeatAssignment(tableId, seatNumber)
        );
        return response.status === 200;
    }
}

export const agentSeatAssignmentService = new AgentSeatAssignmentService();
